import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PrivateRoutes from './PrivateRoutes';
import Dashboard from '../pages/Dashboard';
import Login from '../modules/auth/pages/Login';
import ForgotPassword from '../modules/auth/pages/ForgotPassword';
import ResetPassword from '../modules/auth/pages/ResetPassword';
// import Signup from '../modules/auth/pages/Signup';
import NotFound from '../pages/NotFound';
import Layout from '../layouts/Layout';
import Permissions from '../modules/permissions/pages/Permissions';
import MasterData from '../modules/masterData/pages/MasterData';

import FBZProducts from '../modules/products/pages/FBZProducts';
import FBZCustomers from '../modules/customers/pages/FBZCustomers';
import CateringCustomers from '../modules/customers/pages/CateringCustomers';
import LOBProducts from '../modules/products/pages/LOBProducts';
import FBZCustomerGroup from '../modules/customers/pages/FBZCustomerGroup';
import CateringCustomerGroup from '../modules/customers/pages/CateringCustomerGroup';
import Logistics from '../modules/orders/pages/Logistics';
import FBZOrders from '../modules/orders/pages/FBZOrders';
import PickingList from '../modules/orders/pages/PickingList';
import Inventory from '../modules/inventory/pages/Inventory';
import SalesSummary from '../modules/orders/pages/reports/salesSummary';
import SalesQuantity from '../modules/orders/pages/reports/salesQuantity';

import Profile from '../modules/auth/pages/Profile';

const AppRoutes = () => (
  <Routes>
    {/* Public Routes */}
    <Route path="/login" element={<Login />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="/reset-password" element={<ResetPassword />} />
    {/* <Route path="/signup" element={<Signup />} /> */}

    {/* Protected Routes */}
    <Route element={<PrivateRoutes />}>
      <Route path="/" element={<Layout />}>
        <Route index element={<FBZOrders />} />
        <Route path="/orders-catering" element={<FBZOrders />} />
        <Route path="/permissions" element={<Permissions />} />
        <Route path="/logistics" element={<Logistics />} />
        <Route path="/fbz-products" element={<FBZProducts />} />
        <Route path="/lob-products" element={<LOBProducts />} />
        <Route path="/master-data" element={<MasterData />} />
        <Route path="/fbz-orders" element={<FBZOrders />} />
        <Route path="/catering-orders" element={<FBZOrders />} />

        {/* coming soon routes... */}
        <Route path="/fbz-picking-list" element={<PickingList />} />
        <Route path="/catering-picking-list" element={<PickingList />} />
        {/* <Route path="/catering-picking-lists" element={<Dashboard />} /> */}
        <Route path="/fbz-inventory" element={<Inventory />} />

        <Route path="/fbz-sales-summary" element={<SalesSummary />} />
        <Route path="/fbz-sales-quantity" element={<SalesQuantity />} />
        <Route path="/fbz-sales-analysis" element={<SalesQuantity />} />
        {/* <Route path="/catering-inventory" element={<Dashboard />} /> */}
        {/* <Route path="/notifications" element={<Dashboard />} /> */}
        <Route path="/setting" element={<Profile />} />
        <Route path="/fbz-customers" element={<FBZCustomers />} />
        <Route path="/fbz-customers-group" element={<FBZCustomerGroup />} />
        <Route
          path="/catering-customers-group"
          element={<CateringCustomerGroup />}
        />
        <Route path="/catering-customers" element={<CateringCustomers />} />
      </Route>
    </Route>

    {/* Fallback */}
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AppRoutes;
